<script>
import InboxDocumentReassignmentDialog from '@/components/inbox/InboxDocumentReassignmentDialog.vue'
import InboxNoteDialog from '@/components/inbox/InboxNoteDialog.vue'
import {EventBus} from '@/helpers/eventBus.js'

export default {
  components: {
    InboxDocumentReassignmentDialog,
    InboxNoteDialog,
  },
  props: {
    item: { type: Object },
    inboxes: { type: Array }
  },
  data: () => ({
    fallbackPDFFilename: 'downloaded.pdf',
    displayNoteDialog: false,
    displayModal: false,
    loadingPreview: false,
    loadingDownload: false
  }),
  methods: {
    can(item, operation){
      if(item?.actions){
        switch(operation){
          case 'view':
            return item?.actions?.canView
          case 'transfer':
            return item?.actions?.canTransfer
          case 'download':
            return item?.actions?.canDownload
          case 'userNote':
            return item?.actions?.canUserNote;
        }
      }
      return true
    },
    openReassignDialog() {
      EventBus.$emit('pause-timer')
      this.displayModal = true
    },
    openNoteDialog() {
      EventBus.$emit('pause-timer')
      this.displayNoteDialog = true
    },
    reassignToAnotherInbox({ document, inbox }) {
      this.$inboxService.reassignDocumentToAnotherInbox(document?.id, inbox?.id)
        .then(response => {
          this.$notify(this.$t(
            'component.inbox.move.document.success', {
              'document_id': document?.workItemId,
              'inbox': inbox?.inboxname
            }), {type:'success'})
          this.$emit('item-updated', response.data)
        })
        .catch(error => {
          this.$notify(this.$t(
            'component.inbox.move.document.error', {
              document_id: document.workItemId }), {type:'error'})
          console.error('Assignment Error: ', error)
        })
        .finally(() => {
          this.displayModal = false
          // this.$store.commit('setSelectedInbox', {id: '', inboxname: '', deletionDeadline: ''})
          this.$emit('highlight-row')
          EventBus.$emit('resume-timer')
        })
    },
    abortReassignment() {
      this.displayModal = false
      this.$emit('highlight-row')
      EventBus.$emit('resume-timer')
    },
    openPDF(item) {
      this.loadingPreview = true
      this.$inboxService
        .getDocumentDetails(item.id)
        // .getDocumentPreview(item.id)
        .then(response => {
          const blob = new Blob([response], { type: 'application/pdf' })
          const pdfUrl = URL.createObjectURL(blob)
          window.open(pdfUrl, '_blank')
        })
        .catch(error => {
          console.error('Error while opening PDF: ', error)
        })
        .finally(() => {
          this.$emit('highlight-row')
          this.loadingPreview = false
        })
    },
    downloadPDF(item) {
      this.loadingDownload = true
      this.$inboxService.getDocumentDetails(item.id)
        .then(response => {
          const blob = new Blob([response], { type: 'application/pdf' })
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = item.filename;
          link.click();
        })
        .catch(error => {
          console.error('Error while downloading PDF: ', error)
        })
        .finally(() => {
          this.$emit('highlight-row')
          this.loadingDownload = false
        })
    },
    saveNote({ document, inboxNote }) {
      this.$inboxService.setInboxNote(document.id, inboxNote)
        .then(response => {
          this.$notify(this.$t(
            'component.inbox.note.success', {
              document_id: document.workItemId }), {type:'success'})
          this.$emit('item-updated', response.data)
        })
        .catch(error => {
          this.$notify(this.$t(
            'component.inbox.note.error', {
              document_id: document.workItemId }), {type:'error'})
          console.error('Assignment Error: ', error)
        })
        .finally(() => {
          this.displayNoteDialog = false
          this.$emit('highlight-row')
          EventBus.$emit('resume-timer')
        })
    },
    abortNote() {
      this.displayNoteDialog = false
      this.$emit('highlight-row')
      EventBus.$emit('resume-timer')
    }
  }
}
</script>
<template>
  <div class="inbox-button-container">
    <!--    OPEN PDF-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          class="mx-2"
          fab
          :dark="can(item, 'view')"
          small
          color="primary"
          :disabled="!can(item, 'view')"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="openPDF(item)">
          <v-icon
            v-if="loadingPreview"
            class="mdi-spin"
            dark>mdi-loading
          </v-icon>
          <v-icon v-else dark>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('button.view.document') }}
      </span>
    </v-tooltip>
    <!--    CHANGE INBOX-->
    <v-tooltip
      v-if="item.inboxStatus !== 3"
      bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          v-if="$store.getters.userInboxes.length > 1"
          class="mx-2"
          fab
          :dark="can(item, 'transfer')"
          small
          color="primary"
          :disabled="!can(item, 'transfer')"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="openReassignDialog">
          <v-icon dark>mdi-forward</v-icon>
        </v-btn>
      </template>
      <span> {{ $t('button.change.inbox') }}</span>
    </v-tooltip>
    <!--    DOWNLOAD PDF-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          class="mx-2"
          fab
          :dark="can(item, 'download')"
          small
          color="primary"
          :disabled="!can(item, 'download')"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="downloadPDF(item)">
          <v-icon
            v-if="loadingDownload"
            class="mdi-spin"
            dark>mdi-loading
          </v-icon>
          <v-icon v-else dark>mdi-cloud-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.download') }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          class="mx-2"
          fab
          :dark="can(item, 'userNote')"
          small
          color="primary"
          :disabled="!can(item, 'userNote')"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="openNoteDialog">
          <v-badge
            v-if="item.userNote"
            color='warning'
            dot
            overlap>
            <v-icon>mdi-message-text</v-icon>
          </v-badge>
          <v-icon v-else dark>mdi-message-text</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.add.note') }}</span>
    </v-tooltip>
    <!-- ADD INBOX NOTE DIALOG -->
    <InboxNoteDialog
      v-model="displayNoteDialog"
      :document="item"
      @saveNote="saveNote"
      @cancel="abortNote" />
    <!-- CHANGE INBOX DIALOG-->
    <InboxDocumentReassignmentDialog
      :key="displayModal"
      v-model="displayModal"
      :document="item"
      @ok="reassignToAnotherInbox"
      @cancel="abortReassignment"
      @item-updated="$emit('item-updated', $event)" />
  </div>
</template>
<style scoped>
.v-badge__badge .warning{
  inset: auto auto calc(100% - 5px) calc(100% - 4px)!important;
}
</style>
